export const HELP_SECTIONS = ["All Users", "School Admins", "Association Admins", "Super Admins"];

export const HELP_ROLE_OPTIONS = [
  ["public", "Visitors (not logged in)"],
  ["viewer", "Viewer"],
  ["coach", "Coach"],
  ["school_admin", "School Admin"],
  ["association_admin", "Association Admin"],
  ["super_admin", "Super Admin"],
];

export const htmlToText = (html) => {
  const d = document.createElement("div");
  d.innerHTML = html || "";
  return d.textContent || "";
};

export const topicText = (t) =>
  [t.title, htmlToText(t.content), ...(t.faqs || []).flatMap(f => [f.q, htmlToText(f.a)])].join(" ").toLowerCase();

// Wrap matches of `term` inside text nodes of (already sanitized) HTML with <mark>.
export function highlightHtml(html, term) {
  if (!term) return html;
  const doc = new DOMParser().parseFromString(`<div>${html}</div>`, "text/html");
  const rx = new RegExp(term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "gi");
  const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT);
  const nodes = [];
  while (walker.nextNode()) nodes.push(walker.currentNode);
  nodes.forEach(n => {
    if (!rx.test(n.nodeValue)) return;
    rx.lastIndex = 0;
    const span = doc.createElement("span");
    span.innerHTML = n.nodeValue.replace(/[&<>]/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;" }[c])).replace(rx, m => `<mark>${m}</mark>`);
    n.replaceWith(...span.childNodes);
  });
  return doc.body.firstChild.innerHTML;
}

export function snippet(t, term) {
  const text = [htmlToText(t.content), ...(t.faqs || []).map(f => `${f.q} ${htmlToText(f.a)}`)].join(" ");
  const i = text.toLowerCase().indexOf(term.toLowerCase());
  if (i < 0) return text.slice(0, 140);
  return (i > 60 ? "…" : "") + text.slice(Math.max(0, i - 60), i + 100) + "…";
}
